// extracted by mini-css-extract-plugin
export default {"burger":"style_burger__-As+W"};